import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorSSOAccountMenuSearch = () => {
  const ssoAccountMenuSearch = useCallback((body, callback, loading) => {
    const payload = { ...body }
    ApiService.jsonRequest('/sso/account-menu/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { ssoAccountMenuSearch }
}

export default InteractorSSOAccountMenuSearch
